import { NgModule } from '@angular/core'; 
import { ToggleActiveDirective } from './toggle-active.directive';
import { MatchValueDirective } from './match-value.directive';
import { TrueFalseValueDirective } from './true-false-value.directive';

@NgModule({
  declarations: [ToggleActiveDirective,MatchValueDirective, TrueFalseValueDirective
    ],
  exports: [ToggleActiveDirective, MatchValueDirective, TrueFalseValueDirective]
})
export class UtilsModule {}
